import { render } from "./btcDownload.vue?vue&type=template&id=11a732ea"
import script from "./btcDownload.vue?vue&type=script&lang=js"
export * from "./btcDownload.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__